import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import Link from 'components/Link'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'

import { DEFAULT_PRODUCT_CARD_HEIGHT, handleScrollTo } from './helpers'

import classes from './NavigationList.module.scss'

/** @type {import("./types").default} */
const NavigationList = ({ navSections = [], active, scrollOffset = DEFAULT_PRODUCT_CARD_HEIGHT, isDrawerOpen }) => {
  const { addEvent } = useEventContext()

  return (
    <div className={clsx('NavigationList', classes.list)} aria-label="navigation">
      {navSections.map(section => (
        <div
          id={`#${section.id}`}
          className={clsx(classes.listItem, {
            [classes.mdDrawerOpen]: isDrawerOpen,
          })}
          key={`${section.id}-navSection`}
        >
          <Link
            onClick={() => handleScrollTo(section.id, scrollOffset)}
            className={clsx(classes.listLink, { [classes.active]: active === section.id })}
            {...addEvent({
              engagementComponent: 'table-of-contents',
              engagementDestination: `jump-to_product_${section.id}`,
              engagementDetails: 'navigation-tab',
              name: 'engagement_navigation',
            })}
          >
            <span className={classes.listIcon}>
              <Icon icon={['far', section.icon]} />
            </span>
            <Typography className={classes.listLinkTypography} component="span" variant="body-sm">
              {section.name}
            </Typography>
          </Link>
        </div>
      ))}
    </div>
  )
}

export default NavigationList
